export enum WDLayerTypeEnum {
  model,
  radar,
  satellite,
}
